import { useUserHistory } from 'app/api/HistoryApi';
import { diff } from 'deep-diff';
import { Preloader } from 'llui';
import JSONTree from 'react-json-tree';
import { AddIcon, DeleteIcon, EditIcon } from 'tombac-icons';
import "./ActivityHistory.css";
import { ActivityItem } from "./ActivityItem";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isEmpty = x => x === undefined || x === null || typeof x === 'object' && Object.keys(x).length === 0;
export const diffItems = (lhs, rhs) => {
  const delta = diff(lhs, rhs);
  if (!delta) {
    return [];
  }
  const diffs = delta.filter(_ref => {
    let {
      path
    } = _ref;
    const exclude = ['rev', 'timestamp', 'author', 'revType'];
    const isExcluded = !!exclude.find(i => path.includes(i));
    return !isExcluded;
  }).map(diff => {
    if (diff.kind === 'A') {
      diff = {
        ...diff,
        ...diff.item,
        path: [...diff.path, diff.index]
      };
    }
    const {
      kind,
      path,
      lhs,
      rhs
    } = diff;
    return {
      kind: {
        N: 'add',
        D: 'delete',
        E: 'edit',
        A: 'edit'
      }[kind],
      path,
      lhs,
      rhs
    };
  }).filter(_ref2 => {
    let {
      lhs,
      rhs
    } = _ref2;
    return !isEmpty(lhs) || !isEmpty(rhs);
  });
  return diffs;
};
export const Data = props => {
  if (props.data === undefined || props.data === null) {
    return /*#__PURE__*/_jsx("i", {
      children: "Nothing"
    });
  }
  if (typeof props.data !== 'object') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: JSON.stringify(props.data)
    });
  }
  if (Object.keys(props.data).length === 0) {
    return /*#__PURE__*/_jsx("i", {
      children: "Nothing"
    });
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      margin: '0 -10px'
    },
    "data-sentry-component": "Data",
    "data-sentry-source-file": "ActivityHistory.tsx",
    children: /*#__PURE__*/_jsx(JSONTree, {
      data: props.data,
      theme: {
        scheme: 'bright',
        author: 'chris kempson (http://chriskempson.com)',
        base00: '#000000',
        base01: '#303030',
        base02: '#505050',
        base03: '#b0b0b0',
        base04: '#d0d0d0',
        base05: '#e0e0e0',
        base06: '#f5f5f5',
        base07: '#ffffff',
        base08: '#fb0120',
        base09: '#fc6d24',
        base0A: '#fda331',
        base0B: '#a1c659',
        base0C: '#76c7b7',
        base0D: '#6fb3d2',
        base0E: '#d381c3',
        base0F: '#be643c'
      },
      hideRoot: true,
      "data-sentry-element": "JSONTree",
      "data-sentry-source-file": "ActivityHistory.tsx",
      "data-sentry-element": "JSONTree"
    })
  });
};
export function PropertyChange(_ref3) {
  let {
    kind
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: "PropertyChange",
    "data-sentry-component": "PropertyChange",
    "data-sentry-source-file": "ActivityHistory.tsx",
    children: /*#__PURE__*/_jsx("div", {
      className: "PropertyChange__icon",
      children: {
        add: /*#__PURE__*/_jsx(AddIcon, {
          size: "xs"
        }),
        edit: /*#__PURE__*/_jsx(EditIcon, {
          size: "xs"
        }),
        delete: /*#__PURE__*/_jsx(DeleteIcon, {
          size: "xs"
        })
      }[kind]
    })
  });
}
function ActivityHistory(props) {
  const [history] = useUserHistory(props.email);
  if (!history) {
    return /*#__PURE__*/_jsx(Preloader, {});
  }
  if (history.length === 0) {
    return /*#__PURE__*/_jsx("div", {
      children: "No recorded history"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-sentry-component": "ActivityHistory",
    "data-sentry-source-file": "ActivityHistory.tsx",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "ActivityItem__row ActivityItem__row--Head ActivityItem__row--disabled",
      children: [/*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: "Action"
      }), /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: "Initiator"
      }), /*#__PURE__*/_jsx("div", {
        className: "ActivityItem__row-item",
        children: "Date"
      })]
    }), history.slice(0, 99).map((item, index) => /*#__PURE__*/_jsx(ActivityItem, {
      item: item,
      showTarget: false
    }, `${index}${item.rev}`))]
  });
}
export default ActivityHistory;